// The CommandBar in @uifabric/experiments has 'graduated'.
// Consumer projects should switch to using the version from 'office-ui-fabric-react' before Fabric 7.
export * from 'office-ui-fabric-react/lib/CommandBar';
